import { Box, Flex, Heading } from "@chakra-ui/react";
import { PartnerTier, PartnerTierType } from "@iloq/shared/IPartnerInfo";
import { ReactElement, useMemo } from "react";

export function PartnerInfoHeader({
  tier,
  partnerName,
}: {
  tier: PartnerTierType;
  partnerName: string;
}): ReactElement {
  const purple = "#1A1B31";

  const { bgColor, color } = useMemo(() => {
    if (tier === PartnerTier.PLATINUM) {
      return {
        bgColor:
          "radial-gradient(40% 180% at 25% 75%, #F5F4F4 0%, rgba(133, 133, 133, 0.56) 100%), #FFF",
        color: purple,
      };
    }
    if (tier === PartnerTier.GOLD) {
      return {
        bgColor: "brand.beige",
        color: purple,
      };
    }
    return { bgColor: "brand.purple", color: "white" };
  }, [tier]);

  return (
    <Flex
      background={bgColor}
      justifyContent="space-between"
      width="100%"
      borderTopRadius="16px"
      paddingY="sm"
      paddingX="2xl"
      alignItems="center"
      boxShadow="0px -5px 108px 0px rgba(255, 255, 255, 0.33);"
    >
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="84"
          height="28"
          viewBox="0 0 84 28"
          fill="none"
        >
          <path d="M5.6338 9.01509H0.349792V27.0964H5.6338V9.01509Z" fill={color} />
          <path
            d="M5.9836 3.27968C5.9836 1.62659 4.64253 0.283615 2.9918 0.283615C1.34107 0.283615 0 1.62659 0 3.27968C0 4.93276 1.34107 6.27574 2.9918 6.27574C4.64253 6.27574 5.9836 4.93216 5.9836 3.27968Z"
            fill={color}
          />
          <path
            d="M45.9605 15.2157C45.9605 19.3233 42.6117 22.654 38.4813 22.654C34.3503 22.654 31.0021 19.3233 31.0021 15.2157C31.0021 11.1076 34.3509 7.77627 38.4813 7.77627C42.6117 7.77627 45.9605 11.107 45.9605 15.2157ZM51.0403 15.2157C51.0403 8.3167 45.4173 2.72404 38.4813 2.72404C31.5448 2.72404 25.9224 8.3167 25.9224 15.2157C25.9224 22.1136 31.5454 27.7062 38.4813 27.7062C45.4173 27.7062 51.0403 22.1136 51.0403 15.2157Z"
            fill={color}
          />
          <path
            d="M25.3305 22.121H16.436V3.28568H11.0166V27.0964H22.4891L25.3305 22.121Z"
            fill={color}
          />
          <path
            d="M75.999 22.7409C77.591 20.6476 78.5362 18.0408 78.5362 15.2139C78.5362 11.2737 76.6962 7.76721 73.8302 5.47893L71.1067 9.81317C72.5508 11.1682 73.4564 13.0834 73.4564 15.2139C73.4564 19.322 70.1077 22.6528 65.9772 22.6528C65.0489 22.6528 64.163 22.4794 63.3436 22.1699L60.6226 26.5006C62.2481 27.2665 64.0594 27.705 65.9772 27.705C65.9808 27.705 65.9844 27.705 65.988 27.705L65.9772 27.7164H80.1672L82.8445 23.4547L83.2428 22.7409H75.999Z"
            fill={color}
          />
          <path
            d="M71.4579 3.95593C69.8012 3.15338 67.945 2.69572 65.9787 2.69572C59.0433 2.69572 53.4209 8.28778 53.4209 15.1856C53.4209 19.1744 55.3058 22.7199 58.2329 25.0058L60.9504 20.6811C59.4476 19.3213 58.5007 17.3653 58.5007 15.1856C58.5007 11.0775 61.8488 7.74795 65.9793 7.74795C66.9568 7.74795 67.8869 7.94049 68.7417 8.28058L71.4579 3.95593Z"
            fill={color}
          />
        </svg>
      </Box>
      <Heading as="h3" fontSize={{ base: "sm", md: "md" }} fontWeight="bold" color={color}>
        {partnerName}
      </Heading>
    </Flex>
  );
}
